/**
 * TanStack Router: /workforce/employees/new
 *
 * Employee creation page route
 */
import { createFileRoute } from '@tanstack/react-router'
import CreateEmployeePage from '@/app/workforce/employees/new/page'

/**
 * Route: /workforce/employees/new
 * Layout: _auth (authenticated)
 * Component: CreateEmployeePage
 */
export const Route = createFileRoute('/_auth/workforce/employees/new')({
  component: CreateEmployeePage,
})
